var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[((_vm.url))?_c('img',{attrs:{"src":_vm.url}}):_c('img',{staticClass:"placeholder",attrs:{"src":_vm.placeholder_image}})])}
var staticRenderFns = []

export { render, staticRenderFns }